<template>
    <div class="common-layout">
        <div class="content">
            <div class="top">
                <div class="header">
                    <img alt="logo" class="logo" src="../assets/images/minitable-logo.png" />
                    <span class="title">{{ $t('register.title') }}</span>
                </div>
                <div class="desc">{{ $t('register.desc') }}</div>
            </div>
            <div class="form-wrap">
                <a-form layout="vertical">
                    <a-form-item :label="$t('register.tappo_id')">
                        <a-input v-model:value="form.tappo_id" size="large" disabled />
                    </a-form-item>
                    <a-form-item :label="$t('register.merchant_name')" required>
                        <a-input
                            v-model:value="form.merchant_name"
                            size="large"
                            :placeholder="$t('register.merchant_name_ph')"
                        />
                    </a-form-item>
                    <a-form-item :label="$t('register.email')" required>
                        <a-input
                            v-model:value="form.email"
                            size="large"
                            :placeholder="$t('register.email_ph')"
                        />
                    </a-form-item>
                    <a-form-item :label="$t('register.phone')" required>
                        <a-input
                            v-model:value="form.phone"
                            size="large"
                            :placeholder="$t('register.phone_ph')"
                        />
                    </a-form-item>
                    <a-form-item :label="$t('register.place_id')">
                        <a-input
                            v-model:value="form.place_id"
                            size="large"
                            :placeholder="$t('register.place_id_ph')"
                        />
                    </a-form-item>
                    <a-form-item>
                        <a-button
                            type="primary"
                            size="large"
                            block
                            :loading="submitting"
                            @click="submit"
                        >
                            {{ $t('register.submit') }}
                        </a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="link" block @click="$router.replace('/login')">
                            {{ $t('register.back_login') }}
                        </a-button>
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { applyEmbedFromQuery } from '../kits/embedMode';

function readPrefillFromStorage() {
    try {
        const raw = window.sessionStorage.getItem('sso_register_prefill');
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export default {
    name: 'RegisterPage',
    data() {
        return {
            submitting: false,
            form: {
                tappo_id: '',
                merchant_name: '',
                email: '',
                phone: '',
                place_id: ''
            }
        };
    },
    computed: {
        ...mapState({
            store_prefill: (state) => state.sso.register_prefill
        })
    },
    created() {
        const enabled = applyEmbedFromQuery(this.$route.query);
        this.APP_SET_EMBED_MODE(enabled);
        this.applyPrefill();
    },
    methods: {
        applyPrefill() {
            const q = this.$route.query || {};
            const fromStore = this.store_prefill || readPrefillFromStorage() || {};

            this.form.tappo_id = q.tappo_id || fromStore.tappo_id || '';
            this.form.merchant_name = q.merchant_name || fromStore.merchant_name || '';
            this.form.email = q.email || fromStore.email || '';
            this.form.phone = q.phone || fromStore.phone || '';
            this.form.place_id = q.place_id || fromStore.place_id || '';
        },
        async submit() {
            if (
                !this.form.tappo_id ||
                !this.form.merchant_name ||
                !this.form.email ||
                !this.form.phone
            ) {
                this.$notification.warning({
                    message: this.$t('register.missing_required')
                });
                return;
            }

            this.submitting = true;
            try {
                const biz = await this.register_merchant({
                    tappo_id: this.form.tappo_id,
                    merchant_name: this.form.merchant_name,
                    email: this.form.email,
                    phone: this.form.phone,
                    place_id: this.form.place_id || undefined
                });

                if (biz.code === 100000) {
                    const redirect =
                        (biz.data && biz.data.redirect_url) || '/waitlist';
                    this.$router.replace({ path: redirect });
                }
            } catch (e) {
                console.error(e);
                this.$notification.error({
                    message: this.$t('register.submit_failed')
                });
            } finally {
                this.submitting = false;
            }
        },
        ...mapActions({
            register_merchant: 'sso/register_merchant'
        }),
        ...mapMutations({
            APP_SET_EMBED_MODE: 'app/APP_SET_EMBED_MODE'
        })
    }
};
</script>

<style scoped>
.common-layout {
    display: flex;
    overflow: auto;
    flex-direction: column;
    height: 100vh;
}
.content {
    flex: 1;
    padding: 32px 0 48px;
}
@media (min-width: 768px) {
    .content {
        padding: 80px 0 48px;
    }
}
.top {
    text-align: center;
}
.header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    line-height: 44px;
}
.logo {
    margin-right: 16px;
    height: 44px;
    vertical-align: top;
}
.title {
    position: relative;
    top: 2px;
    font-weight: 600;
    font-size: 28px;
}
.desc {
    margin-top: 12px;
    margin-bottom: 32px;
    font-size: 14px;
    color: #666;
}
.form-wrap {
    margin: 0 auto;
    width: 420px;
    max-width: 95%;
}
</style>
